export const shouldUseSig4Interceptor = () => {
    const sig4Config = window['kConf_csc.center.frontendSig4Conf'];
    // 如果注入失败，默认启用 避免影响请求
    if (!sig4Config) {
        return true;
    }
    return sig4Config && sig4Config.openSig4Check !== false;
};

export const filterUrl = urlList => {
    try {
        return urlList
            .filter(item => item !== '/') // 过滤掉 '/'
            .map(item => {
                // 如果有 a/b/c/* => a/b/c/
                if (item.includes('/*')) {
                    return item.replace('/*', '/');
                }
                return item;
            });
    } catch (error) {
        console.warn('filterUrl 处理失败:', error);
        return [];
    }
};

export const getSig4ConfigParams = () => {
    const sig4Config = window['kConf_csc.center.frontendSig4Conf'];
    const { sig4UrlInclusionList = [], sig4UrlExclusionList = [] } = sig4Config || {};
    if (!sig4Config) {
        return {
            includePaths: ['/'],
            excludePaths: [],
        };
    }
    // 如果存在包含列表，优先使用包含模式
    if (sig4UrlInclusionList && sig4UrlInclusionList.length > 0) {
        return {
            includePaths: filterUrl(sig4UrlInclusionList),
            excludePaths: [],
        };
    }
    // 如果存在排除列表，使用排除模式（默认包含所有路径）
    if (sig4UrlExclusionList && sig4UrlExclusionList.length > 0) {
        return {
            includePaths: ['/'],
            excludePaths: filterUrl(sig4UrlExclusionList),
        };
    }
    // 默认情况：无任何配置
    return {
        includePaths: [],
        excludePaths: [],
    };
};